import { useContext } from "react";
import { TaskbarControllerContext } from "../contexts";

/**
 * Provides the taskbar controller context.
 * @returns The taskbar controller context.
 */
export const useTaskBar = () => {
  const context = useContext(TaskbarControllerContext);
  if (!context) {
    throw new Error(
      "useTaskBar must be used within a TaskbarControllerContext",
    );
  }
  return context;
};
